import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import DashboardLayout from "@/components/dashboard/DashboardLayout";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const method = searchParams.get("method");

  useEffect(() => {
    // Clear any pending enrollment data
    sessionStorage.removeItem('pendingEnrollment');
  }, []);

  return (
    <DashboardLayout role="student">
      <div className="max-w-2xl mx-auto px-4 py-16 text-center">
        <div className="mb-8">
          {method === "card" ? (
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-green-100 rounded-full">
                <CheckCircle2 className="h-16 w-16 text-green-600" />
              </div>
            </div>
          ) : (
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-amber-100 rounded-full">
                <Clock className="h-16 w-16 text-amber-600" />
              </div>
            </div>
          )}
        </div>

        <h1 className="text-3xl font-bold mb-4">
          {method === "card" ? "Payment Successful!" : "Payment Initiated"}
        </h1>

        <p className="text-lg text-gray-600 mb-8">
          {method === "card" 
            ? "Your payment has been processed successfully. Your enrollment is now active."
            : "Your cash payment request has been received. Please complete the payment at our office to activate your enrollment."}
        </p>

        <div className="space-y-4">
          <Button
            onClick={() => navigate("/student-dashboard/my-enrollments")}
            className="w-full"
          >
            View My Enrollments
          </Button>
          <Button
            onClick={() => navigate("/student-dashboard/courses")}
            variant="outline"
            className="w-full"
          >
            Browse More Courses
          </Button>
        </div>
      </div>
    </DashboardLayout>
  );
} 